import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CellContentCustom } from "@/components/CellContentCustom/CellContentCustom";
import { useMapContext } from "@/domains/map";
import { useLocation } from "@/components/Sections/Location/hooks/useLocation";
import { useBrandUrl } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { Box, useBreakpointValue } from "@gemini/core";
import { Divider } from "@gemini/ui";
import { AddressTestId } from "@/components/Sections/Location/components/Address/AddressWrapper";
import { HardfactsPublicTransports } from "./HardfactsPublicTransports";
import { useBrowserAPI } from "@/hooks/useBrowserAPI";
import { useCdpNavigate } from "@/app/router";
import { CLIENT_ROUTES } from "@/app/router/constants";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const HardfactsLocationEntries = () => {
    const { t } = useI18n();
    const isMobile = useBreakpointValue({
        base: true,
        md: false,
    });
    const { setIsSidebarOpen } = useMapContext();
    const { bDocument } = useBrowserAPI();
    const isPreviewMode = useIsPreviewMode();
    const { address } = useLocation() || {};
    const { street, district, city, zipCode } = address || {};
    const parts = [];
    if (street)
        parts.push(street);
    if (district)
        parts.push(district);
    const cityZipCode = zipCode ? ` (${zipCode})` : "";
    if (city || zipCode) {
        const cityZip = city ? `${city}${cityZipCode}` : `(${zipCode})`;
        parts.push(cityZip);
    }
    const fullAddress = parts.join(", ");
    const addressPlaceholderUrl = useBrandUrl({
        endpoint: "/shared/images/map/address-map.png",
    });
    const travelTimePlaceholderUrl = useBrandUrl({
        endpoint: "/shared/images/map/travel-time.png",
    });
    const navigate = useCdpNavigate();
    const scrollToLocationSection = () => {
        const locationSection = bDocument.getElementById("location");
        locationSection === null || locationSection === void 0 ? void 0 : locationSection.scrollIntoView({ behavior: "smooth" });
    };
    const handleAddressPress = () => {
        scrollToLocationSection();
    };
    const handleOpen = () => {
        if (isPreviewMode)
            return;
        if (isMobile) {
            setIsSidebarOpen(true);
        }
        navigate(CLIENT_ROUTES.MAP);
    };
    return (_jsxs(Box, { display: "flex", flexDirection: "column", gap: {
            "breakpoint.base": "spacing.8",
            "breakpoint.lg": "spacing.4",
        }, marginVertical: {
            "breakpoint.base": "spacing.16",
            "breakpoint.xl": "spacing.24",
        }, alignItems: "center", children: [_jsx(Box, { width: "100%", marginBottom: "spacing.8", children: _jsx(Divider, { "aria-hidden": "true" }) }), _jsx(CellContentCustom, { title: fullAddress, body: _jsx(HardfactsPublicTransports, {}), onPress: handleAddressPress, placeholderStart: {
                    url: addressPlaceholderUrl,
                    alt: "address-icon",
                }, testId: AddressTestId }), _jsx(CellContentCustom, { display: { "breakpoint.base": "none", "breakpoint.lg": "flex" }, title: t("hardfacts.travel_times_entry.title"), description: t("hardfacts.travel_times_entry.description"), body: "", onPress: handleOpen, placeholderStart: {
                    url: travelTimePlaceholderUrl,
                    alt: "travel-time-icon",
                }, isClickDisabled: isPreviewMode }), _jsx(Box, { width: "100%", marginTop: "spacing.8", children: _jsx(Divider, { "aria-hidden": "true" }) })] }));
};
